import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/** Extract a URL from a shared text payload (Instagram/TikTok often share "Caption text https://...") */
function pickUrl(...candidates) {
  for (const c of candidates) {
    if (!c) continue;
    const trimmed = c.trim();
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    const match = trimmed.match(/https?:\/\/[^\s]+/i);
    if (match) return match[0];
  }
  return null;
}

export default function Share() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const url = pickUrl(params.get("url"), params.get("text"), params.get("title"));
    if (url) {
      // A share action is an explicit user gesture, so URL processing can begin immediately.
      navigate(`/app/extract?url=${encodeURIComponent(url)}&auto=1`, { replace: true });
    } else {
      navigate("/app/extract", { replace: true });
    }
  }, [params, navigate]);

  return (
    <div className="text-center py-20" data-testid="share-handoff">
      <div className="flex justify-center gap-2 mb-4">
        <span className="w-2 h-2 rounded-full bg-[hsl(var(--primary))] simmer" />
        <span className="w-2 h-2 rounded-full bg-[hsl(var(--secondary))] simmer-2" />
        <span className="w-2 h-2 rounded-full bg-[hsl(var(--primary))] simmer-3" />
      </div>
      <p className="font-serif italic text-2xl">Recibiendo enlace…</p>
    </div>
  );
}
